var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPageIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21870",
    "data-name": "\\uADF8\\uB8F9 21870",
    transform: "translate(-977 -441.295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28206",
    "data-name": "\\uC0AC\\uAC01\\uD615 28206",
    width: 32,
    height: 32,
    transform: "translate(977 441.295)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21822",
    "data-name": "\\uADF8\\uB8F9 21822",
    transform: "translate(981.116 445.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_59",
    "data-name": "\\uC120 59",
    y1: 5.841,
    x2: 5.841,
    transform: "translate(5.429 5.21)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_60",
    "data-name": "\\uC120 60",
    y1: 5.841,
    x2: 5.841,
    transform: "translate(11.271 11.051)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_61",
    "data-name": "\\uC120 61",
    x2: 7.36,
    y2: 7.36,
    transform: "translate(14.706 14.348)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28083",
    "data-name": "\\uC0AC\\uAC01\\uD615 28083",
    width: 3.735,
    height: 14.008,
    rx: 1.868,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 11.887)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28084",
    "data-name": "\\uC0AC\\uAC01\\uD615 28084",
    width: 3.735,
    height: 14.008,
    rx: 1.868,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 9.244, 2.641)",
    fill: "none",
    stroke: "#343a40",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageIcon4);
export default __webpack_public_path__ + "static/media/MyPageIcon4.ef09c9f39051abeab36f056e7d354114.svg";
export { ForwardRef as ReactComponent };